<template>
  <div class="global-search-contain">
    <app-auto-complete
      @selected="selectedItem"
      :placeholder="$t('app.search')"
      :fetchSuggestions="fetchSuggestions"
      :renderItemText="renderItemText"
    >
    </app-auto-complete>
  </div>

</template>
<script>
import AppAutoComplete from '@/components/app-autocomplete';
import InvoiceProxy from '@/store/proxies/invoice-proxy';

export default {
  name: 'AppGlobalSearch',
  components: {
    AppAutoComplete,
  },
  methods: {
    async fetchSuggestions(searchText) {
      if (searchText.length <= 1) {
        return [];
      }

      try {
        const result = await new InvoiceProxy().globalSearch(searchText);
        const { invoices, customers, vendors } = result;
        const invoiceList = invoices.map((invoice) => {
          return {
            ...invoice,
            type: invoice.kind_of ? 'out_come' : 'in_come',
          };
        });
        const customerList = customers.map((customer) => {
          return {
            ...customer,
            type: 'customer',
          };
        });
        const vendorList = vendors.map((vendor) => {
          return {
            ...vendor,
            type: 'vendor',
          };
        });
        return [...invoiceList, ...customerList, ...vendorList];
      } catch (error) {
        return [];
      }
    },
    selectedItem($event, result) {
      console.log('result', result);
    },
    renderItemText(result) {
      if (!result) {
        return null;
      }
      switch (result.type) {
        case 'out_come':
          return `
            <div class="global-search-item">
              <i class="fal fa-file-invoice"></i>
              <p class="company-name">${result.buyer_name}</p>
            </div>
          `;
        case 'in_come':
          return `
            <div class="global-search-item">
              <i class="fal fa-file-invoice"></i>
              <p class="company-name">${result.seller_name}</p>
            </div>
          `;
        case 'customer':
          return `
            <div class="global-search-item">
              <i class="fal fa-user"></i>
              <p class="company-name">${result.company_name}</p>
            </div>
          `;
        default:
          return `
            <div class="global-search-item">
              <i class="fal fa-user-tie"></i>
              <p class="company-name">${result.company_name}</p>
            </div>
          `;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/global-search/index.vue